import { APPROVAL_REQUEST_MENU_TYPE } from '@appshared';
import { FuseNavigation } from '@fuse/types';

export const hrmNavigation: FuseNavigation[] = [
  {
    id: 'dashboard',
    title: 'Trang chủ',
    translate: 'NAV.DASHBOARD.TITLE',
    type: 'item',
    svgIcon: 'artstuff_home',
    roles: ['FUNC__FUNC_VIEW__DASHBOARD'],
    classes: 'nav-link__mat-icon--svg-width-unset',
    hidden: false,
    url: '/hrm/dashboard',
  },
  {
    id: 'announcement_center',
    title: 'Kênh thông tin Artstuff',
    translate: 'NAV.ANNOUNCEMENT_CENTER',
    type: 'item',
    svgIcon: 'artstuff_marketing',
    roles: ['FUNC__FUNC_ACCESS__ANNOUNCEMENT'],
    hidden: false,
    url: '/hrm/announcements',
  },
  {
    id: 'approvals',
    title: 'Đơn từ',
    translate: 'NAV.APPROVALS',
    type: 'collapsable',
    svgIcon: 'artstuff_description',
    roles: ['FUNC__FUNC_REQUESTER__APPROVAL', 'FUNC__FUNC_APPROVER__APPROVAL'],
    children: [
      {
        id: APPROVAL_REQUEST_MENU_TYPE.MY_REQUEST,
        title: 'Đơn từ của tôi',
        translate: 'NAV.MYREQUEST.TITLE',
        roles: ['FUNC__FUNC_REQUESTER__APPROVAL'],
        type: 'item',
        icon: '',
        url: '/hrm/approval-requests/my-requests',
        badge: {
          title: 0,
          translate: 'NAV.MYREQUEST.BADGE',
          bg: '#F36022',
          fg: '#FFFFFF',
        },
      },
      {
        id: APPROVAL_REQUEST_MENU_TYPE.MANAGER,
        title: 'Phê duyệt đơn từ',
        translate: 'NAV.APPROVALREQUEST.TITLE',
        roles: ['FUNC__FUNC_APPROVER__APPROVAL'],
        type: 'item',
        icon: '',
        url: '/hrm/approval-requests/request-for-approvals',
        badge: {
          title: 0,
          translate: 'NAV.APPROVALREQUEST.BADGE',
          bg: '#F36022',
          fg: '#FFFFFF',
        },
      },
    ],
  },
  {
    id       : 'group-management',
    title    : 'Quản lý',
    translate: 'NAV.MANAGEMENT.GROUP_NAME',
    roles: ['FUNC__FUNC_MGMT__APPROVAL', 'FUNC__FUNC_MGMT__ANNOUNCEMENT', 'FUNC__FUNC_MGMT__ANNUAL_LEAVE'],
    type     : 'group',
    icon     : 'apps',
    children : [
      {
        id: APPROVAL_REQUEST_MENU_TYPE.HR,
        title: 'Quản lý đơn từ',
        translate: 'NAV.MANAGEDORDER.TITLE',
        roles: ['FUNC__FUNC_MGMT__APPROVAL'],
        type: 'item',
        svgIcon: 'artstuff_form_management',
        url: '/hrm/approval-requests/management-requests',
        badge: {
          title: 0,
          translate: 'NAV.MANAGEDORDER.BADGE',
          bg: '#F36022',
          fg: '#FFFFFF',
        },
      },
      {
        id: APPROVAL_REQUEST_MENU_TYPE.HR,
        title: 'Quản lý kênh thông tin',
        translate: 'NAV.ANNOUNCEMENT_MANAGEMENT.TITLE',
        roles: ['FUNC__FUNC_MGMT__ANNOUNCEMENT'],
        type: 'item',
        svgIcon: 'artstuff_mkt_management',
        url: '/hrm/announcement-management',
        badge: {
          title: 0,
          translate: 'NAV.ANNOUNCEMENT_MANAGEMENT.BADGE',
          bg: '#F36022',
          fg: '#FFFFFF',
        },
      },
      {
        id: 'annual-leave',
        title: 'Danh sách ngày phép',
        translate: 'NAV.SETTING.ANNUAL_LEAVE.TITLE',
        roles: ['FUNC__FUNC_MGMT__ANNUAL_LEAVE'],
        type: 'item',
        svgIcon: 'artstuff_annual_leave',
        url: '/hrm/general-configuration/employee-info/annual-leave',
        badge: {
          title: 0,
          translate: 'NAV.SETTING.ANNUAL_LEAVE.BADGE',
          bg: '#F36022',
          fg: '#FFFFFF',
        },
      },
    ]
  },
  {
    id       : 'group-setting',
    title    : 'Cài Đặt',
    translate: 'NAV.SETTING.GROUP_NAME',
    roles: ['FUNC__FUNC_SETTING__WORKING_TIME', 'FUNC__FUNC_SETTING__PUBLIC_HOLIDAY', 'FUNC__FUNC_SETTING__APPROVAL'],
    type     : 'group',
    icon     : 'apps',
    children : [
      {
        id: 'working-calendar',
        title: 'Lịch Làm Việc',
        translate: 'NAV.SETTING.WORKING_CALENDAR',
        roles: ['FUNC__FUNC_SETTING__WORKING_TIME', 'FUNC__FUNC_SETTING__PUBLIC_HOLIDAY'],
        type: 'collapsable',
        svgIcon: 'artstuff_workingtime',
        children: [
          {
            id: 'working-time',
            title: 'Thời gian làm việc',
            translate: 'NAV.SETTING.WORKING_TIME.TITLE',
            roles: ['FUNC__FUNC_SETTING__WORKING_TIME'],
            type: 'item',
            icon: '',
            url: '/hrm/general-configuration/config-working-schedule/working-time',
            badge: {
              title: 0,
              translate: 'NAV.SETTING.WORKING_TIME.BADGE',
              bg: '#F36022',
              fg: '#FFFFFF',
            },
          },
          {
            id: 'holiday-time',
            title: 'Thời gian nghỉ lễ',
            translate: 'NAV.SETTING.HOLIDAY.TITLE',
            roles: ['FUNC__FUNC_SETTING__PUBLIC_HOLIDAY'],
            type: 'item',
            icon: '',
            url: '/hrm/general-configuration/config-working-schedule/public-holiday',
            badge: {
              title: 0,
              translate: 'NAV.SETTING.HOLIDAY.BADGE',
              bg: '#F36022',
              fg: '#FFFFFF',
            },
          },
        ],
      },
      {
        id: 'application-form-setting',
        title: 'Đơn từ',
        translate: 'NAV.SETTING.APPLICATION_FORM',
        roles: ['FUNC__FUNC_SETTING__APPROVAL'],
        type: 'collapsable',
        svgIcon: 'artstuff_form_setting',
        children: [
          {
            id: 'form-classification-rule',
            title: 'Quy định đơn từ',
            translate: 'NAV.SETTING.APPLICATION_RULE.TITLE',
            roles: ['FUNC__FUNC_SETTING__APPROVAL'],
            type: 'item',
            icon: '',
            url: '/hrm/general-configuration/config-the-request/approval-request-setting',
            badge: {
              title: 0,
              translate: 'NAV.SETTING.APPLICATION_RULE.BADGE',
              bg: '#F36022',
              fg: '#FFFFFF',
            },
          },
          {
            id: 'cut-off-time',
            title: 'Cut-off time đơn từ',
            translate: 'NAV.SETTING.CUT_OFF_TIME.TITLE',
            roles: ['FUNC__FUNC_SETTING__APPROVAL'],
            type: 'item',
            icon: '',
            url: '/hrm/general-configuration/config-the-request/approval-request-rule',
            badge: {
              title: 0,
              translate: 'NAV.SETTING.CUT_OFF_TIME.BADGE',
              bg: '#F36022',
              fg: '#FFFFFF',
            },
          },
          {
            id: 'email-reminder',
            title: 'Email hệ thống',
            translate: 'NAV.SETTING.EMAIL_REMINDER.TITLE',
            roles: ['FUNC__FUNC_SETTING__APPROVAL'],
            type: 'item',
            icon: '',
            url: '/hrm/general-configuration/config-the-request/schedule-send-email',
            badge: {
              title: 0,
              translate: 'NAV.SETTING.EMAIL_REMINDER.BADGE',
              bg: '#F36022',
              fg: '#FFFFFF',
            },
          },
        ],
      },
      {
        id: 'employee-information',
        title: 'Thông tin nhân viên',
        translate: 'NAV.SETTING.EMPLOYEE_INFO',
        roles: ['FUNC__FUNC_APPROVAL_MGMT__APPROVALS', 'FUNC__FUNC_EMPLOYEE_MGMT__EMPLOYEES'],
        type: 'collapsable',
        svgIcon: 'artstuff_employee_info',
        hidden: true,
        children: [
        ],
      }
    ]
  },
  {
    id       : 'group-administrator',
    title    : 'Quản Trị Hệ Thống',
    translate: 'NAV.ADMINISTRATOR.GROUP_NAME',
    roles: ['FUNC__FUNC_ADMIN__EMPLOYEE', 'FUNC__FUNC_ADMIN__ANNUAL_LEAVE'],
    type     : 'group',
    icon     : 'apps',
    children : [
      {
        id: 'employee-data',
        title: 'Dữ liệu nhân viên',
        translate: 'NAV.ADMINISTRATOR.EMPLOYEE_DATA.TITLE',
        roles: ['FUNC__FUNC_ADMIN__EMPLOYEE'],
        type: 'item',
        svgIcon: 'artstuff_upload',
        url: '/hrm/general-configuration/employee-info/upload-excel',
        badge: {
          title: 0,
          translate: 'NAV.ADMINISTRATOR.EMPLOYEE_DATA.BADGE',
          bg: '#F36022',
          fg: '#FFFFFF',
        },
      },
      {
        id: 'available-leave',
        title: 'Ngày phép khả dụng',
        translate: 'NAV.ADMINISTRATOR.AVAILABLE_LEAVE_DATA.TITLE',
        roles: ['FUNC__FUNC_ADMIN__ANNUAL_LEAVE'],
        type: 'item',
        svgIcon: 'artstuff_upload',
        url: '/hrm/general-configuration/employee-info/import-annual-leave',
        badge: {
          title: 0,
          translate: 'NAV.ADMINISTRATOR.AVAILABLE_LEAVE_DATA.BADGE',
          bg: '#F36022',
          fg: '#FFFFFF',
        },
      }
    ]
  },
];
